module.exports = __webpack_public_path__ + "static/media/5 Overhook.5e53b45a.jpg";